<template>
  <div class="prikaz-diagrama">
    <span class="oblika-diagrama">{{ skupaj }} GB</span>
    <diagram-torta
        v-if="podatki !== null"
        :chart-data="podatki">
    </diagram-torta>
  </div>
</template>

<script>
import DiagramTorta from './DiagramTorta.js'

export default {
  props: ['zasedenProstor', 'nezasedenProstor', 'skupaj'],
  components: {
    DiagramTorta
  },
  data () {
    return {
      podatki: null
    }
  },
  mounted () {
    this.NapolniDiagram()
  },
  methods: {
    NapolniDiagram () {
      this.podatki = {
        labels: ['Zaseden prostor', 'Nezaseden prostor'],
        datasets: [
          {
            backgroundColor: ['#a3a3a3', '#f58220'],
            borderWidth: 2,
            data: [this.zasedenProstor, this.nezasedenProstor]
          }
        ]
      }
    }
  }
}
</script>

<style scoped>

.prikaz-diagrama, .prikaz-besedila {
  display: inline-block;
  min-height: 350px;
}

.prikaz-diagrama {
  position: absolute;
  width: 320px;
  left: 700px;
  top: 275px;
}

.prikaz-diagrama label {
  color: black;
}

.oblika-diagrama{
  margin-left: auto;
  display: table;
  margin-right: auto;
  position: relative;
  top: 220px;
  padding-right: 30px;
  color:white;
  font-size: 30px;
  font-weight: bold;
}

@media only screen and (max-width: 1500px) {
  .oblika-diagrama{
    font-size: 20px;
    top: 200px !important;
  }
}

@media only screen and (max-width: 1500px) {
  .prikaz-diagrama {
    position: absolute;
    left: 600px;
    width: 300px;
    top: 275px;
    min-height:unset;
  }
}

@media only screen and (max-width: 1240px) {
  .prikaz-diagrama {
    position: relative;
    /*width: 300px;*/
    /*position: absolute;*/
    left: 50%;
    transform: translate(-50%, -50%);
    top: 160px;
    min-height:unset;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaHramba/KomponentaDiagramPorabe.vue